export const BAKUNE_DRY_LINEUP_PRODUCTS = {
  short: [
    {
      imageSrc: "/images/bakune-dry-lp/lineup1.png",
      imageAlt: "レディース 半袖タイプ",
      linkUrl: "https://tential.jp/products/bakune-dry-womens-25ss-short-t-shirt-set",
    },
    {
      imageSrc: "/images/bakune-dry-lp/lineup2.png",
      imageAlt: "レディース チュニック タイプ",
      linkUrl: "https://tential.jp/products/bakune-dry-womens-25ss-tunic",
    },
    {
      imageSrc: "/images/bakune-dry-lp/lineup3.png",
      imageAlt: "メンズ 半袖タイプ",
      linkUrl: "https://tential.jp/products/bakune-dry-mens-25ss-short-t-shirt-set",
    },
    {
      imageSrc: "/images/bakune-dry-lp/lineup4.png",
      imageAlt: "メッシュタイプ",
      linkUrl: "https://tential.jp/products/bakune-mesh-25ss-long-t-shirt-set",
    },
  ],
  long: [
    {
      imageSrc: "/images/bakune-dry-lp/lineup-mens-long.png",
      imageAlt: "メンズ 長袖タイプ",
      linkUrl: "https://tential.jp/products/bakune-dry-mens-25ss-long-t-shirt-set",
    },
    {
      imageSrc: "/images/bakune-dry-lp/lineup-womens-long.png",
      imageAlt: "レディース 長袖タイプ",
      linkUrl: "https://tential.jp/products/bakune-dry-womens-25ss-long-tshirt-set",
    },
  ],
}

export const BAKUNE_DRY_PRODUCT_IDS = {
  long: {
    mens: "67be9311f7605c28867c7f5d",
    womens: "67be95bff7605c28867d04bf",
  },
  short: {
    mens: "67ca6adcce9a365145b38d0c",
    womens: "67ca7b8ace9a365145b4d9a7",
  },
}
